"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VizClientLineagePanelBody = void 0;
var data_structures_1 = require("@tableau/data-structures");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var HeaderDetails_1 = require("./HeaderDetails");
var SheetFieldsList_1 = require("./SheetFieldsList");
var SparklineQueryWrapper_1 = require("./SparklineQueryWrapper");
var SparklineWithCaption_1 = require("./SparklineWithCaption");
var ViewerPaneStyles_1 = require("./ViewerPaneStyles");
var VizClientDatasourceList_1 = require("./VizClientDatasourceList");
/** Render the body of the lineage panel. */
function VizClientLineagePanelBody(props) {
    return (React.createElement("div", { className: ViewerPaneStyles_1.lineagePanelBody, "data-tb-test-id": 'data-details-panel-body' },
        React.createElement(HeaderDetails_1.HeaderDetails, __assign({}, props, { sparklineElement: props.showSparkline ? React.createElement(SparklineElement, __assign({}, props)) : null })),
        React.createElement(VizClientDatasourceList_1.VizClientDatasourceList, { datasources: props.datasources, workbookVizportalUrlId: props.workbookVizportalUrlId }),
        React.createElement(SheetFieldsList_1.SheetFieldsList, { datasourceFields: props.datasourceFields, worksheetFields: props.worksheetFields, workbookVizportalUrlId: props.workbookVizportalUrlId })));
}
exports.VizClientLineagePanelBody = VizClientLineagePanelBody;
function getHeaderMessageForViewType(viewType) {
    switch (viewType) {
        case 'Dashboard':
            return Localize_1.Messages.ViewingsOfThisDashboard();
        case 'Sheet':
            return Localize_1.Messages.ViewingsOfThisSheet();
        default:
            data_structures_1.assertNever(viewType);
            return '';
    }
}
function SparklineElement(props) {
    return (React.createElement(SparklineQueryWrapper_1.SparklineQueryWrapper, { vizPortalWebClientRequester: props.vizPortalWebClientRequester, viewPath: props.viewPath }, function (_a) {
        var dataPoints = _a.dataPoints;
        return (React.createElement(React.Fragment, null,
            React.createElement(ViewerPaneStyles_1.SparklineHeader, null, getHeaderMessageForViewType(props.viewType)),
            React.createElement(SparklineWithCaption_1.SparklineWithCaption, { caption: Localize_1.Messages.SparklineCaption(), dataPoints: dataPoints })));
    }));
}
//# sourceMappingURL=VizClientLineagePanelBody.js.map